import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { GetStartedLink } from '@/constants/navigation';
import { scrollToAnchorTarget } from '@/lib/motion';
import { FacadeIllustration } from '@/pages/Home/components/FacadeIllustration';
import { Hero } from '@/pages/Home/data';

const HeroTitleId = 'home-hero-title';

export function HeroSection() {
  return (
    <section aria-labelledby={HeroTitleId} className="pad-grid border-b border-grid">
      <div className="section-container grid gap-12 py-16 sm:py-20 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] lg:items-center lg:gap-16 lg:py-28">
        <div>
          <h1
            id={HeroTitleId}
            className="max-w-[16ch] text-4xl font-extrabold leading-[1.04] tracking-tight text-balance text-graphite sm:text-5xl lg:text-6xl"
          >
            {Hero.title}
          </h1>
          <p className="mt-6 max-w-[56ch] text-lg leading-relaxed text-steel sm:text-xl">{Hero.description}</p>
          <div className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-4">
            <Button asChild size="lg">
              <Link to={GetStartedLink.to}>{GetStartedLink.label}</Link>
            </Button>
            <a
              href={Hero.secondaryLink.to}
              onClick={scrollToAnchorTarget}
              className="rounded-sm text-base font-semibold text-graphite underline decoration-grid decoration-2 underline-offset-8 transition-colors hover:decoration-graphite focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-graphite"
            >
              {Hero.secondaryLink.label}
            </a>
          </div>
        </div>
        <div className="w-full max-w-xl lg:max-w-none">
          <FacadeIllustration />
        </div>
      </div>
    </section>
  );
}